
import { Component, Mixins } from "vue-property-decorator";
import Persistence from "@/mixins/persistence";
import SetAsFavoriteMixin from "@/components/shared/thesis/SetAsFavoriteMixin";
import { HomeRow } from "@/view-models";
import { namespace } from "vuex-class";
import { _adminService, _homeService } from "@/services";
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed"
import config from "@/config";

const app = namespace("app");

@Component({
  components: {
    VuePdfEmbed
  }
}) export default class DetailResult extends Mixins(
  Persistence,
  SetAsFavoriteMixin
) {
  private value: HomeRow = {} as HomeRow;

  @app.State
  public lang!: string;
  dialogResetPDFViewer = false;
  get itemId(): number {
    const id: number = (this.$route.params.id as unknown) as number;
    return id;
  }
  get urlPDF(): string {
    const url = `${config.API_BASE_URL}api/request/download/${this.$route.params.id}`;
    console.log(url)
    return url;
  }
  created() {

    //TODO: make request
    this.$root.$on("detailResult", (data: any) => {
      this.value = data;
      this.persistComponentData();
    });
  }

  viewDocument(): void {
    if (!this.isLoggedIn) {
      this.$root.$emit('onNotLogged', 'download');
      return;
    }
    this.dialogResetPDFViewer = true;
  }
}
